var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkFilledOtherProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7958_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.89929 15.7C2.26332 15.8556 2.66579 15.8978 3.05419 15.8212C3.44259 15.7447 3.7989 15.5528 4.07662 15.2707L7.99995 11.3687L11.9233 15.2707C12.1062 15.4563 12.3241 15.6037 12.5645 15.7046C12.8048 15.8054 13.0627 15.8575 13.3233 15.858C13.5912 15.8572 13.8562 15.8035 14.1033 15.7C14.4703 15.5515 14.784 15.2957 15.0034 14.9662C15.2228 14.6366 15.3378 14.2486 15.3333 13.8527V3.33333C15.3322 2.4496 14.9807 1.60237 14.3558 0.97748C13.7309 0.352588 12.8837 0.00105857 12 0L3.99995 0C3.11622 0.00105857 2.26899 0.352588 1.6441 0.97748C1.01921 1.60237 0.667679 2.4496 0.66662 3.33333V13.8527C0.662318 14.2489 0.777671 14.6372 0.997596 14.9667C1.21752 15.2963 1.53178 15.5519 1.89929 15.7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7958_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkFilledOtherProfile);
export default __webpack_public_path__ + "static/media/bookmark-filled-other-profile.70ebd22f72d83b4779b226aa8aedc452.svg";
export { ForwardRef as ReactComponent };